import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AppView from '@common/components/app-view/app-view';
import ReferralShareCard from '@common-components/referral-share-card/referral-share-card';
import { defaultReferStore, markReferVisited, referralVia } from '@common-components/referral-share-card/referral-nav-logic';
import { namespace } from '@common-config/constants';
import { backendApi } from '@common-reducers/backend-api/backend-api';
import { useAnalyticsService } from '@common-reducers/hooks/use-analytics-service';
import { useSafeLocation } from '@common/services/utils';

/** /refer (#276): the dedicated home of the referral program, reachable from the main nav. */
export default function ReferView() {
  const { t } = useTranslation(namespace);
  const analyticsService = useAnalyticsService();
  const location = useSafeLocation();
  const { data, isLoading } = backendApi.useGetMyReferralQuery();
  const via = referralVia(location.search);

  useEffect(() => {
    markReferVisited(defaultReferStore());
    analyticsService.event('referral_page_viewed', { category: 'referral', action: 'view', via });
    // once per visit
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unavailable = !isLoading && !(data?.enabled && data.shareUrl);

  return (
    <AppView showHeader={false}>
      <div data-testid="refer-view" style={{ padding: '40px 24px', overflowY: 'auto', height: '100%', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
          <h1 style={{ fontSize: 28, fontWeight: 700, margin: 0 }}>{t('referral.pageTitle')}</h1>
          <p style={{ marginTop: 8, color: 'var(--color-text-muted, #5b6472)', fontSize: 15, lineHeight: 1.5 }}>
            {t('referral.pageSubtitle')}
          </p>
          {unavailable ? (
            <p data-testid="refer-unavailable" style={{ marginTop: 24 }}>{t('referral.unavailable')}</p>
          ) : (
            <ReferralShareCard variant="page" via={via} />
          )}
        </div>
      </div>
    </AppView>
  );
}
